import styled from 'styled-components';
import VizExCloseButton from 'visitor-ui-component-library/button/VizExCloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDialogOpaque = styled.div.withConfig({
  displayName: "ModalOverlay__StyledDialogOpaque"
})(["position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(45,62,80,0.79);overflow:hidden;transition-delay:0ms;transition-duration:100ms;"]);
const StyledLightboxBody = styled.div.withConfig({
  displayName: "ModalOverlay__StyledLightboxBody"
})(["position:absolute;top:0;left:0;right:0;bottom:0;margin:10%;overflow-y:auto;"]);
const StyledDialogBody = styled(StyledLightboxBody).withConfig({
  displayName: "ModalOverlay__StyledDialogBody"
})(["padding:15px;background:white;"]);
const ModalOverlay = ({
  children,
  className,
  allowClose = true,
  use = 'modal',
  onClose
}) => {
  const BodyComponent = use === 'lightbox' ? StyledLightboxBody : StyledDialogBody;
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(StyledDialogOpaque, {
      children: [allowClose &&
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(VizExCloseButton
      // @ts-ignore need to add cursor pointer
      // @bend-expect trellis-tokenized
      , {
        className: "modal-overlay-close",
        focused: true,
        size: "md",
        "data-test-id": "modal-overlay-close",
        onClick: onClose
      }), /*#__PURE__*/_jsx(BodyComponent, {
        className: className,
        children: children
      })]
    })
  );
};
export default ModalOverlay;